import ToastMessages from "constants/ToastMessages";
import ErrorPage from "components/errors/ErrorPage";
import type { ReactNode } from "react";

function ForbiddenErrorPage(): ReactNode {
  return <ErrorPage title="403" subtitle={ToastMessages.ERROR_FORBIDDEN} />;
}

export default ForbiddenErrorPage;
